export default __webpack_public_path__ + "static/media/down.e4be6c39.svg";